import { useRef, useState } from "react";
import { Typography, Progress, Modal } from "antd";
import Location from "../../../assests/solutionImages/digitalTheme/location-img.svg";
import Phone from "../../../assests/solutionImages/digitalTheme/Phone-Img.svg";
import Mail from "../../../assests/solutionImages/digitalTheme/Msg-Img.svg";


const { Title, Text } = Typography;

const DigitalInterfaceTheme = ({ card }) => {
  // console.log(card);

  const componentRef = useRef();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex p-2 w-full md:py-4 justify-center bg-gray-200">
      <div className="flex flex-col justify-center p-4 w-full max-w-[393px]  bg-white rounded-lg font-montserrat text-[#333333]">
        <div ref={componentRef} className="bg-white ">
          <div
            className={`relative ${card.profileImage && card?.data?.visibleProfileImage ? 'min-h-[345px] max-w-full' : 'h-[100px]'} bg-[#E34506] text-white rounded-md overflow-hidden mt-2`}
            style={
              card.profileImage && card?.data?.visibleProfileImage
                ? {
                    backgroundImage: `url(${card.profileImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }
                : {}
            }
          >
            {/* Overlay */}
            {card.profileImage && card?.data?.visibleProfileImage && (
              <div className="absolute inset-0 bg-black/50 z-0" />
            )}

            {/* Text Content */}
            <div
              className={`flex flex-col justify-end w-full ${card.profileImage && card?.data?.visibleProfileImage ? 'h-[345px]' : 'h-[100px]'} p-3 text-white relative z-10`}
            >
              <p className="font-bold text-2xl break-words">
                {(card?.name || '').toUpperCase()}
              </p>
              <h2 className="font-medium text-2xl break-words">{card?.designation}</h2>
            </div>
          </div>

          <div className="mt-10 space-y-6 ">
            <Title level={2} className="text-start">Contact</Title>
            <div className="flex flex-col space-y-4">
              {/* <div className="flex items-center text-base ">
                <img src={Phone} alt="Phone" />
                <Text className="ml-4">{card?.phone}</Text>
              </div>
              <div className="flex items-center">
                <img src={Mail} alt="Email" />
                <Text className="ml-4">{card?.email}</Text>
              </div> */}
              <div className="flex items-center text-base cursor-pointer" onClick={() => window.open(`tel:${card?.phone}`, '_self')}>
                <img src={Phone} alt="Phone" />
                <Text className="ml-4">{card?.phone}</Text>
              </div>
              <div className="flex items-center cursor-pointer" onClick={() => window.open(`mailto:${card?.email}`, '_self')}>
                <img src={Mail} alt="Email" />
                <Text className="ml-4">{card?.email}</Text>
              </div>
              <div className="flex items-center">
                <img src={Location} alt="Home" />
                <Text className="ml-4">
                  {card?.data?.contact?.address}, {card?.data?.contact?.city}, {card?.data?.contact?.state}, {card?.data?.contact?.country}
                </Text>
              </div>
            </div>
          </div>

          <div className="mt-10 space-y-6">
            <Title className="text-black" level={2}>Experience</Title>
            <div className="grid grid-cols-2 gap-4 mt-4">
              <Text className="mr-2">{card?.data?.experience?.duration} Year</Text>
              <div>
                <Text className="font-semibold block text-sm">{card?.experience?.role}</Text>
                <Text className="block">{card?.data?.experience?.companyName}</Text>
                <Text>{card?.data?.experience?.location}</Text>
              </div>
            </div>
          </div>

          <div className="mt-10 space-y-6">
            <Title className="text-black" level={2}>Education</Title>
            <div className="grid grid-cols-2 gap-4 mt-4">
              <Text className="mr-2">{card?.data?.education?.yearOfPassing}</Text>
              <div>
                <Text className="font-semibold block">{card?.data?.education?.course}</Text>
                <Text className="block">{card?.data?.education?.collegeName}</Text>
              </div>
            </div>
          </div>

          <div className="mt-10 space-y-6">
            <Title className="text-black" level={2}>Skills</Title>
            <div className="flex flex-wrap">
              {card?.data?.skills.split(",").map((skill, index) => (
                <div
                  key={index}
                  className="px-4 py-2 m-1 text-sm rounded-md bg-[#E34506] text-white"
                >
                  {skill.trim()}
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 space-y-6">
            <Title className="text-black" level={2}>Languages</Title>
            <div className="flex justify-center">
              {card?.data?.languages.map((lang, index) => {
                // Determine color based on expertise
                let strokeColor = "#d9d9d9"; // default gray
                if (lang.expertise === "Beginner") strokeColor = "#1777FF"; // blue
                else if (lang.expertise === "Intermediate") strokeColor = "#FFA217"; // orange
                else if (lang.expertise === "Professional") strokeColor = "#52C41A"; // green
                else strokeColor = "#8b5cf6"; // expert or undefined level

                return (
                  <div key={index} className="flex flex-col  items-center mr-4 mb-4">
                    <Progress
                      type="circle"
                      percent={
                        lang.expertise === "Beginner"
                          ? 25
                          : lang.expertise === "Intermediate"
                            ? 50
                            : lang.expertise === "Professional"
                              ? 75
                              : 100
                      }
                      size={80}
                      strokeColor={strokeColor}
                      strokeWidth={8}
                    />
                    <Text className="mt-2">{lang.language}</Text>
                  </div>
                );
              })}
            </div>
          </div>

        </div>

        <Modal
          onCancel={() => setOpen(false)}
          open={open}
          footer={null}
          className="max-w-[380px]"
        >
          <img className="mt-[22px]" src={Location} alt="Add to Home" />
        </Modal>
      </div>
    </div>
  );
};

export default DigitalInterfaceTheme;
